import React, { cloneElement, useRef } from 'react'
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  useDisclosure,
  Heading
} from '@chakra-ui/react'
import PropTypes from 'prop-types'

const Modal = ({ trigger, title, onClose, children, ...otherProps }) => {
  const { isOpen, onOpen, onClose: closeModal } = useDisclosure()
  const triggerRef = useRef()

  const handleModalClose = () => {
    closeModal()
    onClose()
  }

  return (
    <>
      {cloneElement(trigger, { onClick: onOpen, ref: triggerRef })}
      <ChakraModal
        isOpen={isOpen}
        onClose={handleModalClose}
        finalFocusRef={triggerRef}
        closeOnOverlayClick={false}
        motionPreset="slideInBottom"
        {...otherProps}
      >
        <ModalOverlay />
        <ModalContent>
          {title && (
            <ModalHeader borderBottom="1px" borderColor="gray.200">
              <Heading as="h5" size="md">
                {title}
              </Heading>
            </ModalHeader>
          )}
          <ModalCloseButton />
          {typeof children === 'function'
            ? children(handleModalClose)
            : React.cloneElement(children, { closeModal: handleModalClose })}
        </ModalContent>
      </ChakraModal>
    </>
  )
}

Modal.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.string
}
Modal.defaultProps = { onClose: () => {} }

export default Modal
